export default __webpack_public_path__ + "static/72043e8d0cbe899ee7c2ae72a63df7e2.webp";